import { Box, Flex, Textarea, ValidationMessage } from '@modusign/design-system';
import { ChangeEvent } from 'react';

interface ModalTextAreaProps {
  value: string;
  isDirty: boolean;
  onBlur: () => void;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  errorMessage?: string;
  placeholder?: string;
}

export default function ModalTextArea({
  value,
  isDirty,
  onBlur,
  onChange,
  errorMessage,
  placeholder,
}: ModalTextAreaProps) {
  const showInvalidState = !!errorMessage && isDirty;

  return (
    <Flex alignItems="center" flexDirection="column" justifyContent="center">
      <Textarea
        isInvalid={showInvalidState}
        placeholder={placeholder}
        sx={{
          resize: 'none',
        }}
        value={value}
        width="100%"
        onBlur={onBlur}
        onChange={onChange}
      />
      {showInvalidState && (
        <Box mt={2} width="100%">
          <ValidationMessage>{errorMessage}</ValidationMessage>
        </Box>
      )}
    </Flex>
  );
}
